export default "__VITE_ASSET__1d7a6934__"